/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const COMMENTONFEED= createAsyncThunk(
  "commentOnFeed/commentOnFeed",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const commentOnFeedSlice = createSlice({
  name: "commentOnFeedSlice",
  initialState: {
    commentOnFeed: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcommentOnFeed: (state) => {
        state.commentOnFeed.loading = false
        state.commentOnFeed.error = false
        state.commentOnFeed.data = []
        state.commentOnFeed.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(COMMENTONFEED.fulfilled, (state, action) => {
      state.commentOnFeed = {
        ...state.commentOnFeed,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(COMMENTONFEED.pending, (state, action) => {
      state.commentOnFeed = {
        ...state.commentOnFeed,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(COMMENTONFEED.rejected, (state, action) => {
      state.commentOnFeed = {
        ...state.commentOnFeed,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const commentOnFeedAction = {
    COMMENTONFEED,
};

export { commentOnFeedAction };
export default commentOnFeedSlice.reducer;
export const {setInitialStateOfcommentOnFeed} = commentOnFeedSlice.actions